export default () => ({
  isContentLoaded: false,
  heroContent: {},
  descriptionContent: {},
  marketDataContent: {},
  soldDataContent: {},
  comparableContent: {},
  footerContent: {},
});
